import React from 'react';
import './SellFactorPostPrint.scss';
import numericFunction from "../../../utils/NumericFunction";
import {formatToPersianAddComma} from "../../../utils/CommaSeparator";

const SellFactorPostPrint = ({data}) => {

  const fieldColumn = [...data?.data?.column]
  debugger
  try {
    return (
      <div className="main-print-factor">
        {Object.keys(data).length > 0 &&
          <table className="sell-factor-print-table">
            <thead>
            <tr>
              <th className="th-main-head">
                <div className="logo-header">
                  {data?.headerAndFooter.logo !== false &&
                    <img src={data?.headerAndFooter.logo} alt={"logo"}/>
                  }
                  <h6>{data?.headerAndFooter?.header?.shopName}</h6>
                </div>

                <div className="date-header">
                  <div className={"inline-text"}>
                    <p>تـاریخ سفارش :</p>
                    <p>{numericFunction.e2p(data?.headerAndFooter?.header?.date)}</p>
                  </div>
                  <div className={"inline-text"}>
                    <p>شناسه سفارش :</p>
                    <p>{numericFunction.e2p(data?.headerAndFooter?.header?.factorId)}</p>
                  </div>
                </div>
              </th>
            </tr>
            </thead>

            <tbody>
            <tr>
              <th className={"th-address"}>
                <div className="box-address">
                  <div className={"inline-text"}>
                    <p>گیرنده :</p>
                    <h6>{data?.headerAndFooter?.footer?.customerName}</h6>
                  </div>
                  <div className={"inline-row"}>
                    <div className={"inline-text"} style={{width: '50%'}}>
                      <p> استان :</p>
                      <h6>{data?.headerAndFooter?.footer?.customerProvince}</h6>
                    </div>
                    <div className={"inline-text"}>
                      <p> نام شهر :</p>
                      <h6>{data?.headerAndFooter?.footer?.customerCity}</h6>
                    </div>
                  </div>
                  <div className={"inline-row"}>
                    <div className={"inline-text"} style={{width: '50%'}}>
                      <p>کد پستی :</p>
                      <h6>{(data?.headerAndFooter?.footer?.customerPostalCode)}</h6>
                    </div>
                    <div className={"inline-text"}>
                      <p>شماره تماس :</p>
                      <h6>{(data?.headerAndFooter?.footer?.customerMobile)}</h6>
                    </div>
                  </div>
                  <div className={"inline-text"} style={{alignItems: 'flex-start'}}>
                    <p>آدرس</p>
                    <p>:</p>
                    <h6>{(data?.headerAndFooter?.footer?.customerAddress)}</h6>
                  </div>
                </div>

                <div className="box-address">
                  <div className={"inline-text"}>
                    <p>فرستنده :</p>
                    <h6>{data?.headerAndFooter?.header?.shopName}</h6>
                  </div>
                  <div className={"inline-row"}>
                    <div className={"inline-text"} style={{width: '50%'}}>
                      <p> استان :</p>
                      <h6>{data?.headerAndFooter?.header?.province}</h6>
                    </div>
                    <div className={"inline-text"}>
                      <p> نام شهر :</p>
                      <h6>{data?.headerAndFooter?.header?.city}</h6>
                    </div>
                  </div>
                  <div className={"inline-row"}>
                    <div className={"inline-text"} style={{width: '50%'}}>
                      <p>کد پستی :</p>
                      <h6>{(data?.headerAndFooter?.header.psotCode)}</h6>
                    </div>
                    <div className={"inline-text"}>
                      <p>شماره تماس :</p>
                      <h6>{(data?.headerAndFooter?.footer?.shopCallNumber)}</h6>
                    </div>
                  </div>
                  <div className={"inline-text"} style={{alignItems: 'flex-start'}}>
                    <p>آدرس</p>
                    <p>:</p>
                    <h6>{(data?.headerAndFooter?.footer?.shopAddress)}</h6>
                  </div>
                </div>
              </th>
            </tr>

            <tr>
              <th>
                <table className="product-table">
                  <thead>
                  <tr>
                    <th className="th-table-in">
                      <ul>
                        {data?.data?.column.map((v , index) =>
                          <li style={index === 1 ? {width:"50%"} : {width:"15%"}} key={"Li" + index}>{v?.title}</li>
                        )}
                      </ul>
                    </th>
                  </tr>
                  </thead>

                  <tbody>
                  <tr>
                    <th className="th-middle-data">
                      {data?.data?.data.map((v, index) =>
                        <ul key={"Ul" + index}>
                          {fieldColumn.map((q , indexC) =>
                            <li style={indexC === 1 ? {width:"50%"} : {width:"15%"}}>{v[q.field]}</li>
                          )}
                        </ul>
                      )}
                    </th>
                  </tr>
                  </tbody>

                  <tfoot>
                  <tr>
                    <th className="th-table-in">
                    </th>
                  </tr>
                  </tfoot>
                </table>
              </th>
            </tr>

            {data?.headerAndFooter?.footer?.description ?
              <tr>
                <th className={"th-address"}>
                  <div className="box-address">
                    <div className={"inline-text"} style={{alignItems: 'flex-start'}}>
                      <p>توضیحات</p>
                      <p>:</p>
                      <h6>{numericFunction.e2p(data?.headerAndFooter?.footer?.description)}</h6>
                    </div>
                  </div>

                  <div className="box-address th-price-tz">
                    <div className="box-price-bot">
                      <div className="inline-price">
                        <h6> تخفیف</h6>
                        <p>{formatToPersianAddComma(data?.headerAndFooter?.footer?.discount)}</p>
                      </div>
                      <div className="inline-price">
                        <h6> هزینه بسته بندی و ارسال</h6>
                        <p>{formatToPersianAddComma(data?.headerAndFooter?.footer?.servicesPrice)}</p>
                      </div>
                      <div className="inline-price">
                        <h6>مجموع مبلغ نهایی (تومان)</h6>
                        <p>{formatToPersianAddComma(data?.headerAndFooter?.footer?.factorSum)}</p>
                      </div>
                    </div>
                  </div>
                </th>
              </tr> :
              <tr>
                <th className={"th-price"}>
                  <div className="box-price-bot">
                    <div className="h-line"></div>
                    <div className="inline-price">
                      <h6> تخفیف</h6>
                      <p>{formatToPersianAddComma(data?.headerAndFooter?.footer?.discount)}</p>
                    </div>
                    <div className="inline-price">
                      <h6> هزینه بسته بندی و ارسال</h6>
                      <p>{formatToPersianAddComma(data?.headerAndFooter?.footer?.servicesPrice)}</p>
                    </div>
                    <div className="inline-price">
                      <h6>مجموع مبلغ نهایی (تومان)</h6>
                      <p>{formatToPersianAddComma(data?.headerAndFooter?.footer?.factorSum)}</p>
                    </div>
                  </div>
                </th>
              </tr>}

            </tbody>
          </table>
        }
      </div>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default SellFactorPostPrint;